module.exports = __webpack_public_path__ + "static/media/icon-guardia.94b19b3f.svg";